import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EntityHistoryEntryIcon from 'components/EntityHistoryEntryIcon';
import EntityHistoryJsonContext from 'components/EntityHistoryJsonContext';

import { EntityHistoryEntry_entry$key } from '__generated__/EntityHistoryEntry_entry.graphql';

type Props = {
  entry: EntityHistoryEntry_entry$key;
};

const EntityHistoryEntry: FC<Props> = props => {
  const entry = useFragment(
    graphql`
      fragment EntityHistoryEntry_entry on LogEntry {
        name
        createdAt
        description
        user {
          name
        }

        ...EntityHistoryJsonContext_entry
        ...EntityHistoryEntryIcon_entry
      }
    `,
    props.entry
  );

  const { name, description, createdAt, user } = entry;

  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'middle',
            flexWrap: 'wrap',
            width: '30%',
            flexShrink: 0,
          }}>
          <EntityHistoryEntryIcon entry={entry} />
          <Typography>{createdAt}</Typography>
        </Box>

        <Typography sx={{ color: 'text.secondary' }}>{name}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {user && (
          <Typography variant="caption">Vartotojas: {user.name}</Typography>
        )}

        <Typography>{description}</Typography>
        <EntityHistoryJsonContext entry={entry} />
      </AccordionDetails>
    </Accordion>
  );
};

export default EntityHistoryEntry;
